var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.666 0l-1.11 2-2.223.25 1.53 1.54L1.444 6l2.222-1L5.89 6l-.415-2.21L7 2.25 4.777 2l-1.11-2zm0 .747l.867 1.563 1.722.193L5.077 3.69 5.4 5.407l-1.734-.78-1.733.78.322-1.717-1.178-1.187L2.8 2.31 3.666.747z",
    fill: "#456D45"
  })));
}
export default SvgEmptyStar;